import baseApi from "./baseApi"

export default {
    async postUploadActuals(plantID, fileData, confirmedContinueReferences, fileReference){
        let data = new FormData();
        data.set("plantID", plantID);

        // If we have a file reference we don't need to send the file data
        if(fileReference != null){
            data.set("fileDataReference", fileReference);
        } else {
            data.set("fileData", fileData);
        }
        data.set("confirmedContinueReferences", JSON.stringify(confirmedContinueReferences));
        
        let request = await baseApi.createHttpRequest();
        let result = await request.post("/dataImport/uploadActuals", data, {
            headers: {
                "Content-Type": "multipart/form-data; boundary=" + data._boundary
            }
        });
        return result.data;
    }
}